//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/ポップアップ
//------------------------------------------------------------------------------
/**
 * ポップアップを閉じる
 */
export default function closePopup(view, layers) {
  view.closePopup();

  // 一時的に描画した径間グラフィックを削除
  if (layers) {
    layers.linker.removeAll();
  }
}
